export default {
    listApis: state => state.listApis.apis || [],
    listApiEnv: state => state.listApis.env || '',
    listview: state => state.listview.items || [],
    listviewTotal: state => state.listview.total || 0,
    listviewItem: state => state.listviewDetail,
    listApiData: state => state.listApiData || {},

    formApis: state => (state.formApis.apis ? state.formApis.apis.apis : []),
    formApiAuth: state => (state.formApis.apis ? state.formApis.apis.common : []),
    formApiEnv: state => state.formApis.env || '',
    formview: state => state.formview.items || [],
    formviewTotal: state => state.formview.total || 0,
    formviewItem: state => state.formviewDetail,
    formApiData: state => state.formApiData || {},

    engineList: state => state.engineList || []
}
